import axiosInstance from "../axiosClient";

export const generatePresignedUrlsForCustomizationAssests = async (
  token,
  userId,
  logoFileType,
  bgFileType
) => {
  try {
    const response = await axiosInstance.post(
      `/customization/share-assets/${userId}/presigned-urls`,
      {
        logoType: logoFileType,
        bgType: bgFileType,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShareAssetUrls = async ( userId) => {
  try {
    const response = await axiosInstance.get(
      `/customization/${userId}/urls`
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      throw new Error("Assets not found for this user ID");
    }
    throw error;
  }
};

export const saveUploadsDB = async (
  token,
  userId,
  logoKey,
  bgKey,
  logoContentType,
  bgContentType
) => {
  try {
    const response = await axiosInstance.post(
      `/customization/${userId}/save-assets`,
      {
        logoKey,
        bgKey,
        logoContentType,
        bgContentType
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};